import React, { useEffect, useRef, useState } from 'react';
import {
  bool, elementType, func, shape, string, arrayOf, node
} from 'prop-types';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import classNames from 'classnames';
import Helper from '../../../../Helper';
import Threesixty from '../../../Threesixty';
import './main-asset.style.scss';
import '../../../../media-gallery.style.scss';

export const MainAsset = (props) => {
  const {
    isZoomedIn, fwdOverlayRef, mainAsset, onAssetClick, zoomedAsset
  } = props;
  const [coords, setCoords] = useState({ x: 0, y: 0, dragging: false });
  const imageRef = useRef();

  useEffect(() => {
    if (imageRef?.current) {
      imageRef.current.style.left = '0px';
      imageRef.current.style.right = '0px';
    }
  }, [mainAsset]);

  if (!mainAsset) {
    return null;
  }

  const onZoomOut = () => {
    setCoords({ x: 0, y: 0, dragging: false });
    if (onAssetClick) {
      onAssetClick();
    }
  };

  const hasTouch = (event = {}) => {
    return event.type === 'touchmove';
  };

  const startDrag = (event) => {
    const { x, y } = coords;
    let dx = x;
    let dy = y;

    if (event && imageRef?.current) {
      dx = event.clientX - Number(imageRef.current.style.left.substring(0, imageRef.current.style.left.indexOf('px')));
      dy = event.clientY - Number(imageRef.current.style.top.substring(0, imageRef.current.style.top.indexOf('px')));
    }

    setCoords({ x: dx, y: dy, dragging: true });
  };

  const handleMainImageClick = (event) => {
    if (onAssetClick) {
      onAssetClick();
    }
    if (event) {
      startDrag(event);
    }
  };

  const whileDrag = (event) => {
    let xCursor;
    let yCursor;

    const {
      x, y, dragging
    } = coords;

    if (event) {
      xCursor = hasTouch(event) ? (event.changedTouches && event.changedTouches[0].clientX) : event.clientX;
      yCursor = hasTouch(event) ? (event.changedTouches && event.changedTouches[0].clientY) : event.clientY;
    }

    if (imageRef?.current && dragging) {
      imageRef.current.style.left = `${xCursor - x}px`;
      imageRef.current.style.top = `${yCursor - y}px`;
    }
  };

  const isAR = Helper.isAR({ media: mainAsset });
  const isImage = Helper.isImage({ media: mainAsset });
  const isImage360 = Helper.isImage360({ media: mainAsset });
  const isVideo = Helper.isVideo({ media: mainAsset });
  const zoomOutClasses = classNames('main-asset__normal-image-wrapper', {
    'main-asset--hidden': isZoomedIn
  });
  const zoomInClasses = classNames('main-asset__zoom-wrapper', {
    'main-asset--display-block': isZoomedIn,
    'main-asset--hidden': !isZoomedIn
  });

  return (
    <div className="main-asset">
      <div className={zoomInClasses} onMouseMove={whileDrag} onTouchMove={whileDrag}>
        <button className="main-asset__button" onClick={onZoomOut} type="button">
          <img className="main-asset__zoomed-image" src={zoomedAsset.url} alt="" ref={imageRef} />
        </button>
      </div>
      <div className={zoomOutClasses}>
        {isImage360 && (
          <Threesixty
            media={mainAsset}
            fwdOverlayRef={fwdOverlayRef}
            fwdImageRef={imageRef}
          />
        )}
        {(isImage || isAR) && (
          <button className="main-asset__button" onClick={handleMainImageClick} type="button">
            {isImage && (
              <>
                <img className="main-asset__standard-image" src={zoomedAsset.url} alt="" />
                {mainAsset.collection
                && (
                  <div className="shopThisRoomContainer">
                    <a className="shopThisRoomLink" target="_blank" rel="noreferrer" href={mainAsset.collection} onClick={(e) => e && e.stopPropagation()}> Shop This Room </a>
                  </div>
                )}
                <div className="main-asset__cta">
                  {!isZoomedIn && <span>Click or Tap Image to Zoom</span>}
                </div>
              </>
            )}
            {isAR && (
              <>
                <img className="main-asset__standard-image main-asset__standard-image--no-cursor" src={mainAsset.mediaStill} alt="" />
                <span className="background-circle background-circle--main" />
                <span className="ar-icon ar-icon--main" />
              </>
            )}
          </button>
        )}
        {isVideo && (
          <VideoPlayer className="main-asset__video-player" videoId={mainAsset.videoId} />
        )}
      </div>
    </div>
  );

};

MainAsset.propTypes = {
  mainAsset: shape({
    id: string,
    url: string,
    mediaType: string
  }),
  zoomedAsset: shape({
    id: string,
    url: string,
    mediaType: string
  }),
  onAssetClick: func,
  isZoomedIn: bool,
  fwdOverlayRef: shape({ current: elementType })
};

MainAsset.defaultProps = {
  mainAsset: {
    id: '',
    url: '',
    mediaType: ''
  },
  zoomedAsset: {
    id: '',
    url: '',
    mediaType: ''
  },
  onAssetClick: null,
  isZoomedIn: false,
  fwdOverlayRef: null
};

export default MainAsset;
